export function formatRuleLocations(
  location: string[] | string | null | undefined,
  allowedChar: number | null = null
): string {
  if (location == null) {
    return "-";
  }
  if (typeof location === "string") {
    const trimmed = location.trim();
    return trimmed ? trimmed : "-";
  }
  if (!Array.isArray(location) || location.length === 0) {
    return "-";
  }
  const names = location.filter((item) => item && String(item).trim());
  return names.length ? (allowedChar ? (names.join(", ").length > allowedChar ? names.join(", ").slice(0, allowedChar) + '... ' : names.join(", ") ) : names.join(", ") ) : "-";
}
